









































import { Component, Prop, Vue, Watch, Inject } from 'vue-property-decorator';
import { User, Usertorole } from '@/data/models/user.model';
import { CrudService } from '@/data/services/crud.service';
import { Role } from '@/data/models/role.model';
import { Search, SortDirection } from '@/data/models/search.model';
import { Page } from '@/data/models/page.model';

@Component
export default class UtenteRoles extends Vue {
	@Prop() utente!: User;
	@Prop({ default: false }) limit!: boolean;

	@Inject('CrudService') crudService!: CrudService<Role>;
	@Inject('CrudService') userToRoleService!: CrudService<Usertorole>;

	checked: Role[] = [];
	usertoroles: Usertorole[] = [];

	rows: Role[] = [];
	advancedSearch: Search = new Search('role');
	loading: boolean = false;

	constructor() {
		super();
		this.advancedSearch.setSortField('id');
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
	}

	created() {
		this.loadRoles();
	}

	@Watch('utente', { immediate: true })
	onUserChange() {
		this.loadUserRoles();
	}

	loadUserRoles() {
		const search = new Search('usertorole');
		search.addSimpleFilter('uid', this.utente.id);
		this.userToRoleService
			.searchEntities(Usertorole, 'usertorole', search, new Page(100))
			.then((result) => {
				this.usertoroles = result;
				this.checked = this.usertoroles.map((ur) => {
					const role = new Role();
					role.id = ur.rid;
					return role;
				});
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			});
	}

	loadRoles() {
		this.advancedSearch.reset();

		if (this.limit) {
			this.advancedSearch.addSimpleFilter('editable', 1);
		}

		const datareq = this.crudService.searchEntities(
			Role,
			'role',
			this.advancedSearch,
			this.advancedSearch.page
		);
		const countreq = this.crudService.countEntities(
			Role,
			'role',
			this.advancedSearch
		);
		this.loading = true;
		Promise.all([datareq, countreq])
			.then((results) => {
				this.rows = results[0];
				this.advancedSearch.page.setTotal(results[1].ct);
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.loadRoles();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.loadRoles();
	}

	onCheck(rows: Role[], row: Role) {
		const index = rows.indexOf(row);
		if (index >= 0) {
			const model = new Usertorole();
			model.uid = this.utente.id;
			model.rid = row.id;
			this.userToRoleService
				.createEntity(Usertorole, 'usertorole', model)
				.then((result) => {
					this.usertoroles.push(result);
				})
				.catch(({ data }) => {
					this.$buefy.notification.open({
						message: data.msg || data.internal,
						type: 'is-danger',
					});
					// reset change
					rows.splice(index, 1);
				});
		} else {
			const i = this.usertoroles.map((ur) => ur.rid).indexOf(row.id);
			const model = this.usertoroles[i];
			this.userToRoleService
				.deleteEntity(Usertorole, 'usertorole', model)
				.then(() => {
					this.usertoroles.splice(i, index);
				})
				.catch(({ data }) => {
					this.$buefy.notification.open({
						message: data.msg || data.internal,
						type: 'is-danger',
					});
					// reset change
					rows.push(row);
				});
		}
	}
}
